// extracted by mini-css-extract-plugin
export var author = "StoryBlockCard-module--author--c551d";
export var category = "StoryBlockCard-module--category--93a0d";
export var categoryDateWrapper = "StoryBlockCard-module--categoryDateWrapper--f4c04";
export var cta = "StoryBlockCard-module--cta--7b19f";
export var date = "StoryBlockCard-module--date--0f2f7";
export var featured = "StoryBlockCard-module--featured--b8628";
export var foot = "StoryBlockCard-module--foot--c9f1c";
export var image = "StoryBlockCard-module--image--91706";
export var tldr = "StoryBlockCard-module--tldr--2b16a";
export var wrapper = "StoryBlockCard-module--wrapper--ba7e6";